module.exports = __webpack_public_path__ + "assets/img/2017_1.5bdcdc13.png";